module.exports = __webpack_public_path__ + "img/p2-3.b534d730.jpg";